import React from 'react';
import IOUModal from './IOUModal';

// eslint-disable-next-line react/jsx-props-no-spreading
const IOURequestPage = props => <IOUModal {...props} />;
IOURequestPage.displayName = 'IOURequestPage';
export default IOURequestPage;
